import { render, staticRenderFns } from "./beneficial-ownership-edit-form.vue?vue&type=template&id=09012be0&scoped=true&"
import script from "./beneficial-ownership-edit-form.vue?vue&type=script&lang=ts&"
export * from "./beneficial-ownership-edit-form.vue?vue&type=script&lang=ts&"
import style0 from "./beneficial-ownership-edit-form.vue?vue&type=style&index=0&id=09012be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09012be0",
  null
  
)

export default component.exports